import {useTranslation} from '@/translations/i18n'
import {AnswerField, Content, YesNoAnswerField} from '../atoms/Atoms'
import {forwardRef} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Divider} from '@/components/ui/divider/Divider'
import {RemapExperienceForViewOnly} from '@/features/experience-view-only/types'

export const PricingDiscountStep = forwardRef<HTMLDivElement, {experience: RemapExperienceForViewOnly}>(
    ({experience}, ref) => {
        const {t} = useTranslation()

        return (
            <Flexbox direction="column" fullWidth ref={ref}>
                <Content title={t('experience_shell:step_pricing_discount')} margin={6}>
                    <AnswerField
                        labelTitle={t('vetting:criteria:experience:price_per_person')}
                        hasValue={!!experience.expertise.answers.guest_individual_price?.answer}
                        value={experience.expertise.answers.guest_individual_price?.answer}
                    />
                    <YesNoAnswerField
                        labelTitle={t('experience_view_only:allow_private_groups')}
                        yesNoValue={experience.expertise.answers.instance_private_groups?.answer}
                    />

                    {!!experience.expertise.answers.instance_private_groups?.answer && (
                        <AnswerField
                            labelTitle={t('experience_shell:minimum_price')}
                            hasValue={!!experience.expertise.answers.group_minimum_price?.answer}
                            value={experience.expertise.answers.group_minimum_price?.answer}
                        />
                    )}

                    <AnswerField
                        labelTitle={t('experience_shell:maximum_public_group_size')}
                        hasValue={!!experience.expertise.answers.maximum_public_group_size?.answer}
                        value={experience.expertise.answers.maximum_public_group_size?.answer}
                    />
                </Content>

                <Divider direction="horizontal" />

                <Content margin={6}>
                    <YesNoAnswerField
                        labelTitle={t('experience_shell:limited_time')}
                        yesNoValue={!!experience.limitedTimeDiscount}
                    >
                        {experience.limitedTimeDiscount ? `${experience.limitedTimeDiscount}%` : null}
                    </YesNoAnswerField>
                    <AnswerField
                        labelTitle={t('experience_shell:large_group_discount')}
                        hasValue={!!experience.discounts.length}
                    >
                        {experience.discounts.map((discount, index) => {
                            const discountText = t('experience_view_only:groups_discounts', {
                                guests: discount.groupSize,
                                percent: discount.discountInPercentage
                            })
                            return (
                                <li key={`${index}-${discountText}`} title={discountText}>
                                    {discountText}
                                </li>
                            )
                        })}
                    </AnswerField>
                    <YesNoAnswerField
                        labelTitle={t('experience_shell:early_bird_discount')}
                        yesNoValue={experience.expertise.answers.early_bird_discount?.answer}
                    />
                </Content>
            </Flexbox>
        )
    }
)

PricingDiscountStep.displayName = 'PricingDiscountStep'
